import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createContact } from "@/api/v1-jwt/contact/contact";
import { useAuth } from "@/providers/auth";

export const useCreateContact = () => {
  const query = useQueryClient();
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: (payload) => createContact({ userId: id, payload }),
    onSuccess: () => {
      query.invalidateQueries(["contacts"]);
    },
  });
};
